import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  addModal: {
    position: "absolute",
    background: "#F5F8FF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "1168px",
    maxWidth: "95vw",
  },
  modalContainer: {
    padding: "32px 42px",
    background: "#F5F8FF",
  },
  headerModal: {
    color: "#012497",
    fontFamily: "Cairo",
    fontWeight: "800",
    fontSize: "24px",
  },
  bodyContainer: {
    flexWrap: "nowrap",
    alignItems: "stretch",
    marginTop: 0,
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  rightColumn: {
    display: "flex",
    flexDirection: "column",
    flex: "0 0 350px !important",
    width: "350px",
    maxWidth: "350px !important",
    minWidth: 0,
  },
  dividerWrap: {
    display: "flex",
    alignItems: "stretch",
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  divider: {
    borderColor: "#C6C9CA",
  },
  uploadsRight: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    minWidth: 0,
  },
  uploadedPanel: {
    background: "#FFFFFF",
    border: "1px solid #C6C9CA",
    borderRadius: 4,
    minHeight: 56,
    padding: "8px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: 6,
    width: "100%",
    boxSizing: "border-box",
    minWidth: 0,
    flex: 1,
  },
  uploadedItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 8,
  },
  uploadedName: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 14,
    color: "#2A3333",
    flex: 1,
    minWidth: 0,
  },
  noFile: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 14,
    color: "#6C7A7A",
    textAlign: "center",
    width: "100%",
  },
  uploadsError: {
    width: "100%",
    marginLeft: 0,
  },
  uploadedFileCell: {
    backgroundColor: "white",
    padding: "16px",
    borderRadius: "4px",
    border: "1px solid #C6C9CA",
    boxSizing: "border-box",
    minWidth: 0,
  },
  actionsRow: {
    gap: 24,
    marginTop: 16,
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": {
      borderColor: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  saveBtn: {
    background: "#3D63E6",
    color: "#ffff",
    "&:hover": {
      background: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  label: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "16px",
    color: "#2A3333",
    marginBottom: "0px",
  },
}));
